"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGlobalLookup = exports.setGlobalLookup = exports.defaultLookup = void 0;
const get_1 = __importDefault(require("lodash/get"));
const check = it => {
  // Math is known to exist as a global in every environment.
  return it && it.Math === Math && it;
};
// IE11 doesn't support globalThis.
const globalObject = check(typeof globalThis === "object" && globalThis) ||
// eslint-disable-next-line @faire-web/no-restricted-globals
check(typeof window === "object" && window) || check(typeof self === "object" && self) || check(typeof global === "object" && global) || Function("return this")();
const defaultLookup = prop => {
  return (0, get_1.default)(globalObject, prop);
};
exports.defaultLookup = defaultLookup;
let lookupOverride;
const setGlobalLookup = lookup => {
  lookupOverride = lookup;
};
exports.setGlobalLookup = setGlobalLookup;
const getGlobalLookup = () => {
  return lookupOverride !== null && lookupOverride !== void 0 ? lookupOverride : exports.defaultLookup;
};
exports.getGlobalLookup = getGlobalLookup;